"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var omit_1 = __importDefault(require("lodash/omit"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var utils_1 = require("utils/selectors/utils");
var EntryRow_1 = __importDefault(require("./EntryRow"));
var DebugQuickbooks = function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var qbRequests = (0, react_redux_1.useSelector)((0, utils_1.makeSelectOrdered)('debug_quickbooks'));
    (0, react_redux_firebase_1.useFirestoreConnect)({ collection: 'debug_quickbooks' });
    var _a = __read(react_1.default.useState(''), 2), search = _a[0], setSearch = _a[1];
    var _b = __read(react_1.default.useState(''), 2), selectedGroup = _b[0], setGroup = _b[1];
    var groups = Array.from(new Set(qbRequests === null || qbRequests === void 0 ? void 0 : qbRequests.map(function (qBR) { return qBR === null || qBR === void 0 ? void 0 : qBR.entityName; }).filter(Boolean)));
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var emptyDocs = qbRequests === null || qbRequests === void 0 ? void 0 : qbRequests.filter(function (qBR) { return !(qBR === null || qBR === void 0 ? void 0 : qBR.entityName); }).filter(Boolean);
    var entries = react_1.default.useMemo(function () {
        if (!qbRequests) {
            return qbRequests;
        }
        var allEntries = qbRequests
            .map(function (qBR) { return (qBR === null || qBR === void 0 ? void 0 : qBR.entityName)
            && qBR[qBR.entityName].map(function (entr) { return (__assign(__assign({}, entr), { docId: qBR.id, GROUP: qBR === null || qBR === void 0 ? void 0 : qBR.entityName })); }); })
            .filter(Boolean)
            .flat();
        var groupFilteredEntries = selectedGroup
            ? allEntries.filter(function (entry) { return entry.GROUP === selectedGroup; })
            : allEntries;
        return search
            ? groupFilteredEntries
                .filter(function (entry) { return JSON.stringify((0, omit_1.default)(entry, 'GROUP')).toLowerCase().includes(search.toLowerCase()); })
            : groupFilteredEntries;
    }, [search, selectedGroup, qbRequests]);
    if (!entries) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(SimpleTextField, { value: search, onChange: setSearch, placeholder: "Search" }), (0, jsx_runtime_1.jsxs)("select", __assign({ onChange: function (e) { return setGroup(e.currentTarget.value); } }, { children: [(0, jsx_runtime_1.jsx)("option", __assign({ value: "", selected: selectedGroup === '' }, { children: "Show all" })), groups.map(function (group) { return ((0, jsx_runtime_1.jsx)("option", __assign({ value: group, selected: selectedGroup === group }, { children: group }), group)); })] })), "Count: ", entries.length, " |", ' ', "Instructions:", ' ', "(1) Set enableDebug === 'FULL' in integration_connections.", ' ', "(2) Delete collection debug_quickbooks.", ' ', "(3) Run Resync in admin/companies."] }), (0, jsx_runtime_1.jsxs)("div", { children: ["Empty: ", emptyDocs === null || emptyDocs === void 0 ? void 0 : emptyDocs.map(function (d) { return d.id; }).join(', ')] })] }), (0, jsx_runtime_1.jsx)(Table_1.default, __assign({ sx: { height: '78vh' } }, { children: (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: entries.map(function (entry) { return ((0, jsx_runtime_1.jsx)(EntryRow_1.default, { entry: entry }, "".concat(entry.GROUP, "__").concat(entry.docId, "__").concat(entry.Id || JSON.stringify(entry)))); }) }) }))] }));
};
var SimpleTextField = (0, SimplifyFormInput_1.default)(TextField_1.default);
exports.default = DebugQuickbooks;
